import React from 'react';

export const TopicSelector = ({ topics, currentTopic, direction, onTopicChange, onDirectionChange }) => {
  return (
    <div className="topic-selector">
      <div className="selector-grid">
        <select 
          value={currentTopic}
          onChange={(e) => onTopicChange(e.target.value)}
          className="selector-btn active"
        >
          {topics.map(topic => (
            <option key={topic} value={topic}>{topic}</option>
          ))}
        </select>
        <select
          value={direction}
          onChange={(e) => onDirectionChange(e.target.value)}
          className="selector-btn"
        >
          <option value="ar">AR → EN</option>
          <option value="en">EN → AR</option>
        </select>
      </div>
    </div>
  );
};
